import React from "react";
import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import { SignOutButton } from "./SignOutButton";

import "../css/layout.css";

export const PageLayout = (props) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" className={"appbar"}>
        <Toolbar>
          <Box sx={{ height: "4vh", display: "flex", paddingRight: "1vw" }}>
            <img
              src={"./logo_white.png"}
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {"Corpcloud"}
          </Typography>
          <SignOutButton />
        </Toolbar>
      </AppBar>
      <Box>{props.children}</Box>
    </Box>
  );
};
